if(typeof jsConfigOverride === 'undefined') { var e = new Error("Cannot find module 'jsConfigOverride'"); e.code = 'MODULE_NOT_FOUND'; throw e; }

module.exports = jsConfigOverride;